export default __webpack_public_path__ + "static/media/mb-logo.41985860.png";